import { ComponentProps } from 'react'
import { webchatClasses } from '../../../styles/classes'
import { ColumnBlock, type CommonBlockProps } from '../../../types'
import { Block } from '../../Block'

type Props = ColumnBlock & ComponentProps<'div'> & CommonBlockProps
export const Column = ({
  ref,
  blocks,
  horizontalAlignment,
  verticalAlignment,
  direction,
  sender,
  timestamp,
  messageId,
  isReadOnly,
  sendMessage,
  ...props
}: Props) => {
  const {
    message: {
      blocks: { column },
    },
  } = webchatClasses

  return (
    <div data-horizontal={horizontalAlignment} data-vertical={verticalAlignment} {...props} {...column} ref={ref}>
      {blocks.map((block, index) => (
        <Block
          key={index}
          block={{
            ...block,
            direction,
            timestamp,
            sender,
            messageId,
            isReadOnly,
            sendMessage,
          }}
        />
      ))}
    </div>
  )
}

Column.displayName = 'Column'
